// Static form delivery for Back Of The Mind.
//
// Every submission tries the bundled `mail.php` on the HostGator server
// first (12s limit). If the server script is unreachable, errors, or
// stalls, the entry automatically fails over to Web3Forms — so messages
// always land in connectbackofthemind@gmail.com.

// Primary: bundled mail.php on the HostGator server (12s limit, then failover).
// Fallback: Web3Forms — if the server script fails or stalls, the entry is
// re-routed here so it still lands in connectbackofthemind@gmail.com.
// NOTE: a static frontend cannot hide this key from view; Web3Forms is built
// for exactly this client-side pattern (keys are domain-restricted server-side).
export const WEB3FORMS_KEY = "9556d4c0-db65-4bf5-adbd-c432b8cc0300";

const TIMEOUT_MS = 12000;

async function viaMailPhp(subject, fields) {
  const base = new URL("mail.php", document.baseURI);
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const res = await fetch(base, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subject, ...fields }),
      signal: controller.signal,
    });
    if (!res.ok) throw new Error("Server script unavailable");
    const data = await res.json().catch(() => ({}));
    if (!data.success) throw new Error(data.message || "Server script failed");
    return { channel: "mail.php", ...data };
  } finally {
    clearTimeout(timer);
  }
}

async function viaWeb3Forms(subject, fields) {
  // FormData (multipart) is CORS-safelisted: no preflight, so this call
  // succeeds even where Web3Forms' OPTIONS handler would be challenged.
  const fd = new FormData();
  fd.append("access_key", WEB3FORMS_KEY);
  fd.append("subject", `${subject} — Back Of The Mind website`);
  fd.append("from_name", "Back Of The Mind website");
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") fd.append(k, String(v));
  });
  const res = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.message || "Send failed");
  return { channel: "web3forms", ...data };
}

export async function sendForm(subject, fields) {
  try {
    return await viaMailPhp(subject, fields);
  } catch (err) {
    if (!WEB3FORMS_KEY) throw err;
    return viaWeb3Forms(subject, fields);
  }
}
